"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateType = void 0;
var date_fns_1 = require("date-fns");
/** Returns true if `value` is a Date type. */
function isDateType(value) {
    return date_fns_1.isDate(value);
}
exports.isDateType = isDateType;
//# sourceMappingURL=isDateType.js.map